import React, { useState } from "react";
import "./Donate.css";
import DonateAmount from "./DonateAmount";
import DonateBilling from "./DonateBilling";
import DonateSuccess from "./DonateSuccess";
import { useTranslation } from "react-i18next";

const Donate = () => {
  const { t } = useTranslation();
  const [step, setStep] = useState(1);
  const [amount, setAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState("");
  const [donationType, setDonationType] = useState("one-time");

  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  // Calculate progress for the stepper visual
  const progressHeight = ((step - 1) / 2) * 100;
  const progressWidth = ((step - 1) / 2) * 100;

  return (
    <section className="d_donate_section">
      <div className="d_donate_layout">
        
        {/* STEPPER */}
        <div className="d_stepper">
          <div className="d_step_line"></div>
          <div
            className="d_step_progress"
            style={{ 
              "--p-height": `${progressHeight}%`,
              "--p-width": `${progressWidth}%` 
            }}
          ></div>

          {/* STEP 1: Amount */}
          <div className={`d_step ${step >= 1 ? "active" : ""} ${step > 1 ? "completed" : ""}`}>
            <div className="d_step_circle">{step > 1 ? "✓" : "1"}</div>
            <span className="d_step_label">{t("donate.step_amount")}</span>
          </div>

          {/* STEP 2: Billing */}
          <div className={`d_step ${step === 2 ? "active" : ""} ${step > 2 ? "completed" : ""}`}>
            <div className="d_step_circle">{step > 2 ? "✓" : "2"}</div>
            <span className="d_step_label">{t("donate.step_billing")}</span>
          </div>

          {/* SUCCESS */}
          <div className={`d_step ${step === 3 ? "active success" : ""}`}>
            <div className="d_step_circle">✓</div>
            <span className="d_step_label">{t("donate.step_success")}</span>
          </div>
        </div>

        {/* FORM AREA */}
        <div className="d_form_area">
          {step === 1 && (
            <DonateAmount
              donationType={donationType}
              setDonationType={setDonationType}
              amount={amount}
              setAmount={setAmount}
              customAmount={customAmount}
              setCustomAmount={setCustomAmount}
              nextStep={nextStep}
            />
          )}

          {step === 2 && (
            <DonateBilling
              amount={customAmount || amount}
              nextStep={nextStep}
              prevStep={prevStep}
            />
          )}

          {step === 3 && (
            <DonateSuccess amount={customAmount || amount} />
          )}
        </div>
      </div>
    </section>
  );
};

export default Donate;